// Generated by scripts/gen-shapes.ts. Do not edit by hand; change the generator and re-run it.
// Fret per string, low → high; −1 muted, 0 open. Index = root pitch class (C = 0).
import type { ChordQuality } from '../theory/chord';
import type { TableInstrument } from './shapes';

export type ExtendedQuality = Exclude<ChordQuality, 'maj' | 'min'>;

export const EXTENDED_SHAPES: Record<TableInstrument, Record<ExtendedQuality, number[][]>> = {
  guitar: {
    '6': [
      [-1, 3, 2, 2, 1, 0],
      [-1, 4, 3, 3, 6, 4],
      [-1, -1, 0, 2, 0, 2],
      [-1, -1, 1, 0, 1, 3],
      [0, 2, 2, 1, 2, 0],
      [1, 0, 0, 2, 1, 1],
      [-1, -1, 4, 3, 4, 2],
      [3, 2, 0, 0, 0, 0],
      [4, 3, 1, 1, 1, 1],
      [-1, 0, 2, 2, 2, 2],
      [-1, 1, 0, 0, 3, 1],
      [-1, 2, 1, 1, 0, 2],
    ],
    '7': [
      [-1, 3, 2, 3, 1, 0],
      [-1, 4, 3, 1, 0, 1],
      [-1, -1, 0, 2, 1, 2],
      [-1, -1, 1, 0, 2, 3],
      [0, 2, 0, 1, 0, 0],
      [1, 3, 1, 2, 1, 1],
      [2, 4, 2, 3, 2, 2],
      [3, 2, 0, 0, 0, 1],
      [4, 3, 1, 1, 1, 2],
      [-1, 0, 2, 0, 2, 0],
      [-1, 1, 3, 1, 3, 1],
      [-1, 2, 1, 2, 0, 2],
    ],
    maj7: [
      [-1, 3, 2, 0, 0, 0],
      [-1, 4, 3, 1, 1, 1],
      [-1, -1, 0, 2, 2, 2],
      [-1, -1, 1, 0, 3, 3],
      [0, 2, 1, 1, 0, 0],
      [1, 0, 2, 2, 1, 0],
      [2, 4, 3, 3, 2, 2],
      [3, 2, 0, 0, 0, 2],
      [4, 3, 1, 1, 1, 3],
      [-1, 0, 2, 1, 2, 0],
      [-1, 1, 0, 2, 3, 1],
      [-1, 2, 1, 3, 0, 2],
    ],
    m7: [
      [-1, 3, 1, 3, 1, 3],
      [-1, 4, 2, 1, 0, 0],
      [-1, -1, 0, 2, 1, 1],
      [-1, -1, 1, 3, 2, 2],
      [0, 2, 0, 0, 0, 0],
      [1, 3, 1, 1, 1, 1],
      [2, 4, 2, 2, 2, 2],
      [3, 1, 0, 0, 3, 1],
      [4, 6, 4, 4, 4, 4],
      [-1, 0, 2, 0, 1, 0],
      [-1, 1, 3, 1, 2, 1],
      [-1, 2, 0, 2, 0, 2],
    ],
    add9: [
      [-1, 3, 0, 0, 1, 0],
      [-1, 4, 1, 1, 2, 1],
      [-1, -1, 0, 2, 5, 2],
      [-1, -1, 1, 0, 4, 1],
      [0, 2, 2, 1, 0, 2],
      [1, 0, 3, 0, 1, 1],
      [-1, -1, 4, 3, 2, 4],
      [3, 0, 0, 0, 0, 3],
      [4, 1, 1, 1, 1, 4],
      [5, 2, 2, 2, 2, 5],
      [-1, 1, 0, 3, 1, 1],
      [7, 4, 4, 4, 4, 7],
    ],
    sus2: [
      [-1, 3, 0, 0, 1, 3],
      [-1, 4, 1, 1, 2, 4],
      [-1, -1, 0, 2, 3, 0],
      [-1, -1, 1, 3, 4, 1],
      [0, 2, 4, 4, 0, 0],
      [-1, -1, 3, 0, 1, 1],
      [-1, -1, 4, 1, 2, 2],
      [3, 0, 0, 0, 3, 3],
      [4, 1, 1, 1, 4, 4],
      [-1, 0, 2, 2, 0, 0],
      [-1, 1, 3, 3, 1, 1],
      [-1, 2, 4, 4, 2, 2],
    ],
    sus4: [
      [-1, 3, 3, 0, 1, 1],
      [-1, 4, 4, 6, 7, 4],
      [-1, -1, 0, 2, 3, 3],
      [-1, -1, 1, 3, 4, 4],
      [0, 0, 2, 2, 0, 0],
      [1, 1, 3, 3, 1, 1],
      [2, 2, 4, 4, 2, 2],
      [3, 3, 0, 0, 1, 3],
      [4, 4, 6, 6, 4, 4],
      [-1, 0, 0, 2, 3, 0],
      [-1, 1, 1, 3, 4, 1],
      [-1, 2, 4, 4, 0, 0],
    ],
    dim: [
      [-1, -1, 10, 8, 7, 8],
      [-1, 4, 2, 0, 2, 0],
      [-1, -1, 0, 1, 3, 1],
      [-1, -1, 1, 2, 4, 2],
      [-1, -1, 2, 3, 5, 3],
      [-1, -1, 3, 1, 0, 1],
      [-1, -1, 4, 2, 1, 2],
      [-1, -1, 5, 3, 2, 3],
      [4, 2, 0, 1, 0, 4],
      [-1, 0, 7, 5, 4, 5],
      [-1, 1, 2, 3, 2, 0],
      [-1, 2, 0, 4, 0, 1],
    ],
    aug: [
      [-1, 3, 2, 1, 1, 0],
      [-1, 4, 3, 2, 2, 5],
      [-1, -1, 0, 3, 3, 2],
      [-1, -1, 1, 0, 0, 3],
      [-1, -1, 2, 1, 1, 0],
      [-1, -1, 3, 2, 2, 1],
      [-1, -1, 4, 3, 3, 2],
      [3, 2, 1, 0, 0, 3],
      [-1, -1, 6, 5, 5, 0],
      [-1, 0, 3, 2, 2, 1],
      [-1, 1, 0, 3, 3, 2],
      [-1, 2, 1, 0, 0, 3],
    ],
  },
  ukulele: {
    '6': [
      [0, 0, 0, 0],
      [1, 1, 1, 1],
      [2, 2, 2, 2],
      [0, 3, 3, 3],
      [1, 1, 0, 2],
      [2, 2, 1, 0],
      [3, 3, 2, 1],
      [0, 2, 0, 2],
      [1, 0, 1, 3],
      [2, 1, 2, 0],
      [0, 2, 1, 1],
      [1, 3, 2, 2],
    ],
    '7': [
      [0, 0, 0, 1],
      [1, 1, 1, 2],
      [2, 2, 2, 3],
      [0, 3, 3, 4],
      [1, 2, 0, 2],
      [2, 3, 1, 0],
      [3, 4, 2, 1],
      [0, 2, 1, 2],
      [1, 0, 2, 3],
      [0, 1, 0, 0],
      [1, 2, 1, 1],
      [2, 3, 2, 2],
    ],
    maj7: [
      [0, 0, 0, 2],
      [1, 1, 1, 3],
      [2, 2, 2, 4],
      [0, 3, 3, 5],
      [1, 3, 0, 2],
      [2, 4, 1, 0],
      [3, 5, 2, 4],
      [0, 2, 2, 2],
      [1, 0, 3, 3],
      [1, 1, 0, 0],
      [2, 2, 1, 1],
      [3, 3, 2, 2],
    ],
    m7: [
      [3, 3, 3, 3],
      [1, 1, 0, 2],
      [2, 2, 1, 3],
      [3, 3, 2, 4],
      [0, 2, 0, 2],
      [1, 3, 1, 3],
      [2, 4, 2, 0],
      [0, 2, 1, 1],
      [1, 3, 2, 2],
      [0, 0, 0, 0],
      [1, 1, 1, 1],
      [2, 2, 2, 2],
    ],
    add9: [
      [0, 2, 0, 3],
      [1, 3, 1, 4],
      [2, 4, 2, 5],
      [0, 3, 1, 1],
      [1, 4, 2, 2],
      [0, 0, 1, 0],
      [1, 1, 2, 1],
      [2, 2, 3, 2],
      [1, 0, 4, 1],
      [2, 1, 0, 2],
      [3, 2, 1, 3],
      [4, 3, 2, 4],
    ],
    sus2: [
      [0, 2, 3, 3],
      [1, 3, 4, 4],
      [2, 2, 0, 0],
      [3, 3, 1, 1],
      [4, 4, 2, 2],
      [0, 0, 1, 3],
      [1, 1, 2, 4],
      [0, 2, 3, 0],
      [1, 3, 4, 1],
      [2, 4, 0, 2],
      [3, 0, 1, 1],
      [4, 1, 2, 2],
    ],
    sus4: [
      [0, 0, 1, 3],
      [1, 1, 2, 4],
      [0, 2, 3, 0],
      [1, 3, 4, 1],
      [2, 4, 0, 2],
      [3, 0, 1, 1],
      [4, 1, 2, 2],
      [0, 2, 3, 3],
      [1, 3, 4, 4],
      [2, 2, 0, 0],
      [3, 3, 1, 1],
      [4, 4, 2, 2],
    ],
    dim: [
      [5, 3, 2, 3],
      [0, 1, 0, 4],
      [7, 5, 4, 5],
      [2, 3, 2, 0],
      [0, 4, 0, 1],
      [4, 5, 4, 2],
      [2, 0, 2, 0],
      [0, 1, 3, 1],
      [4, 2, 4, 2],
      [5, 3, 5, 0],
      [3, 1, 0, 1],
      [4, 2, 1, 2],
    ],
    aug: [
      [1, 0, 0, 3],
      [2, 1, 1, 0],
      [3, 2, 2, 1],
      [0, 3, 3, 2],
      [1, 0, 0, 3],
      [2, 1, 1, 0],
      [3, 2, 2, 1],
      [0, 3, 3, 2],
      [1, 0, 0, 3],
      [2, 1, 1, 0],
      [3, 2, 2, 1],
      [0, 3, 3, 2],
    ],
  },
};
